import { useMediaQuery } from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { STATUS, WILDCARD } from "../../../enums/LocalStorageValues";
import * as DOTS from "../appointments/enums/StatusDots";
import { userTableParams } from "../users/DesktopUserListingPage";
import { STATUSES } from "../../../enums/AppointmentStatus";

function getIconByStatus(status) {
  switch (status) {
    case STATUSES.WAITING_CLINIC:
      return DOTS.PENDING_SMALL;
    case STATUSES.WAITING_USER:
      return DOTS.PENDING_SMALL; // TODO: change this to a different icon color with a different ticket, check css to match colors
    case STATUSES.ACTIVE:
      return DOTS.ACTIVE_SMALL;
    case STATUSES.FINISHED:
      return DOTS.DONE_SMALL;
    case STATUSES.RESOLVED:
      return DOTS.RESOLVED_SMALL;
    case STATUSES.INACTIVE:
      return DOTS.REJECTED_SMALL;
    default:
      return DOTS.PAST_SMALL;
  }
}

function checkIfStatusIsActive(filter, status) {
  if (checkIfStatusIsInArray(filter, status)) {
    return "primary";
  } else {
    return "default";
  }
}

//Yes these 2 functions are the same, but there was a rendering issue and this was the easiest way to fix it...
function checkIfStatusIsInArray(filter, status) {
  return getLocalStorageStatus().includes(status);
}
const statusTitle = [
  { title: STATUSES.ACTIVE, value: STATUSES.ACTIVE },
  { title: STATUSES.WAITING_CLINIC, value: STATUSES.WAITING_CLINIC },
  { title: STATUSES.INACTIVE, value: STATUSES.INACTIVE },
  { title: STATUSES.RESOLVED, value: STATUSES.RESOLVED },
  { title: STATUSES.FINISHED, value: STATUSES.FINISHED },
];

const FilteringActions = {
  SET_DATE: "set-date",
  SET_STATUS: "set-status",
  REMOVE_STATUS: "remove-status",
  RESET_FILTER: "reset-filter",
  INITIAL: "initial",
  SET_WILDCARD: "set-wildCard",
  RESET_FILTER_DESKTOP: "desktop-reset",
  RESET_FILTER_MOBILE: "mobile-reset",
};

const parseLocalStorageStatus = () => {
  if (localStorage.getItem(STATUS)) {
    return localStorage.getItem(STATUS).split(",");
  }
};

const getLocalStorageStatus = () => {
  if (
    parseLocalStorageStatus(localStorage.getItem(STATUS)) == "" ||
    parseLocalStorageStatus(localStorage.getItem(STATUS)) == undefined
  ) {
    return [];
  }
  return parseLocalStorageStatus(localStorage.getItem(STATUS));
};

//initial reducer state for mobile
const FilterInitialState = {
  dateRange: { startDate: "", endDate: "" },
  status: getLocalStorageStatus()
    ? getLocalStorageStatus()
    : [STATUSES.ACTIVE, "PAST", STATUSES.INACTIVE],
  wildCard: localStorage.getItem(WILDCARD),
};

const FilterInitialStateMobile = {
  dateRange: { startDate: "", endDate: "" },
  status: getLocalStorageStatus()
    ? getLocalStorageStatus()
    : [STATUSES.ACTIVE, "PAST", STATUSES.INACTIVE],
  wildCard: localStorage.getItem(WILDCARD),
};

//initial reducer state
const FilterInitialStateDesktop = {
  dateRange: { startDate: "", endDate: "" },
  status: [STATUSES.ACTIVE],
  wildCard: "",
};
const getLocalStorageWildCard = () => {
  return localStorage.getItem(WILDCARD);
};

function setReducerStatus(payload, state) {
  var arr = getLocalStorageStatus();
  if (!arr.includes(payload)) {
    arr.push(payload);
  }
  localStorage.setItem(STATUS, arr);
  return { ...state, status: getLocalStorageStatus() };
}

function removeReducerStatus(payload, state) {
  var arr = getLocalStorageStatus();
  const index = arr.indexOf(payload);
  if (index > -1) {
    arr.splice(index, 1);
  }
  localStorage.setItem(STATUS, arr);
  return { ...state, status: getLocalStorageStatus() };
}

// The 2 reducer functions are practically identical, but currently I can't figure out a way to make them a single reducer...
const FilterReducerDesktop = (state, { type, payload }) => {
  var arr = [STATUSES.ACTIVE];
  switch (type) {
    case FilteringActions.SET_DATE:
      return { ...state, dateRange: payload };
    case FilteringActions.SET_WILDCARD:
      return { ...state, wildCard: payload };
    case FilteringActions.SET_STATUS:
      return setReducerStatus(payload, state);
    case FilteringActions.REMOVE_STATUS:
      return removeReducerStatus(payload, state);
    case FilteringActions.RESET_FILTER:
      localStorage.setItem(STATUS, arr);
      localStorage.setItem(WILDCARD, "");
      return { ...FilterInitialStateDesktop, wildCard: "", status: arr };
    case FilteringActions.INITIAL:
      return { ...FilterInitialStateDesktop };
    default:
      return state;
  }
};
const FilterReducerMobile = (state, { type, payload }) => {
  var arr = [STATUSES.ACTIVE, "PAST", STATUSES.INACTIVE];
  switch (type) {
    case FilteringActions.SET_DATE:
      return { ...state, dateRange: payload };
    case FilteringActions.SET_WILDCARD:
      return { ...state, wildCard: payload };
    case FilteringActions.SET_STATUS:
      return setReducerStatus(payload, state);
    case FilteringActions.REMOVE_STATUS:
      return removeReducerStatus(payload, state);
    case FilteringActions.RESET_FILTER:
      localStorage.setItem(STATUS, arr);
      localStorage.setItem(WILDCARD, "");
      return { ...FilterInitialStateMobile, wildCard: "", status: arr };
    case FilteringActions.INITIAL:
      return { ...FilterInitialStateMobile };
    default:
      return state;
  }
};

function useUserFiltering() {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const isDesktop = useMediaQuery("(min-width: 769px)");
  const reducer = isDesktop ? FilterReducerDesktop : FilterReducerMobile;

  const [filter, dispatch] = React.useReducer(reducer, {
    wildCard: searchParams.get("search") ?? "",
  });

  function handleWildCardData(search) {
    if (search && search != "") {
      const params = new URLSearchParams(searchParams);
      params.delete(userTableParams.page);
      params.set(userTableParams.page, Number(0));
      params.set(userTableParams.wildcard, String(search));
      setSearchParams(params);
      dispatch({
        type: FilteringActions.SET_WILDCARD,
        payload: searchParams.get(userTableParams.wildcard),
      });
    } else {
      resetFilter();
    }
  }

  function resetFilter() {
    params.delete(userTableParams.wildcard);
    params.set(userTableParams.page, Number(0));
    params.delete(userTableParams.clinic);
    params.delete(userTableParams.active);
    params.delete(userTableParams.withoutPets);
    params.delete(userTableParams.withoutReservations);
    params.delete(userTableParams.sort);
    setSearchParams(params);
    dispatch({ type: FilteringActions.RESET_FILTER });
  }

  return {
    filter,
    handleWildCardData,
    resetFilter,
  };
}

export {
  checkIfStatusIsActive,
  checkIfStatusIsInArray,
  FilteringActions,
  FilterInitialState,
  getIconByStatus,
  getLocalStorageStatus,
  getLocalStorageWildCard,
  parseLocalStorageStatus,
  removeReducerStatus,
  setReducerStatus,
  statusTitle,
  useUserFiltering,
};
